import { inject, Injectable, signal } from "@angular/core";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { filter } from "rxjs";
import {  UserTypeStateService } from '../state/user-type-state.service';
import { APP_CONFIG } from "@ribera-web/app-token";

@Injectable({
  providedIn: 'root',
})
export class ShellDataService {

  private router = inject(Router)
  private route = inject(ActivatedRoute);
  private userTypeStateService = inject(UserTypeStateService);
  private config = inject(APP_CONFIG);

  isDashboardRoute = signal(false);
  viewSidebarRight = signal(false);
  // isPromotorPerfil = signal<boolean>(JSON.parse(localStorage.getItem('isPromotorPerfil') || 'false'));
  private returnUrl: string | null = null;
  isPromotorPerfil = signal<boolean>(true);

  constructor() {

    this.router.events.pipe(
      filter(e => e instanceof NavigationEnd)
    ).subscribe(() => {
      this.updateRouteState();
    });

    this.updateRouteState();
  }

  private updateRouteState() {

    const url = this.router.url;

    // const isSocio = url.startsWith('/socio');

    const dashboardPaths = ['promotor-dashboard','promotor-my-data','dashboard'];
    const sidebarPaths = ['promotor-dashboard','promotor-wallet','promotor-booking','promotor-my-benefits', 'promotor-bookings'];

    const segments = url.split('?')[0].split('/').filter(Boolean);
    const lastSegment = segments.pop() || '';

    this.isDashboardRoute.set(
      dashboardPaths.includes(lastSegment)
    );

    this.viewSidebarRight.set(
      sidebarPaths.includes(lastSegment)
    );
  }

  togglePromotorPerfil() {
    const newValue = !this.isPromotorPerfil();
    this.isPromotorPerfil.set(newValue);

    // localStorage.setItem('isPromotorPerfil', JSON.stringify(newValue));
    const token = localStorage.getItem('accessToken');

    if (newValue) { 
      // this.userTypeStateService.setType('promotor');
      localStorage.removeItem('accessToken');
      window.location.href = `${this.config.URL_RIBERA_PROMOTERS}/promotor-dashboard?token=${token}`;
      // this.router.navigate(['/promotor-dashboard']);
      console.log('Navegando a /promotor-dashboard porque se ha activado el perfil de promotor');
    } else {
      // this.viewSidebarRight.set(false);
      // this.userTypeStateService.setType('usuario');
      localStorage.removeItem('accessToken');
      window.location.href = `${this.config.URL_RIBERA_WEB}/dashboard?token=${token}`;
      // this.router.navigate(['/dashboard']);
      console.log('Navegando a /dashboard y ocultando sidebar derecho');
    }
  }

  redirectPerfilStorage(){

    this.returnUrl = this.route.snapshot.queryParamMap.get('returnUrl');

    if (this.returnUrl) {
        window.location.href = this.returnUrl;
      } else {
        this.router.navigate(['/promotor-dashboard']);
      }

    // const newValue = JSON.parse(localStorage.getItem('isPromotorPerfil') || 'false');
    // this.isPromotorPerfil.set(newValue);

    // if (newValue) {
    //   if (this.returnUrl) {
    //     window.location.href = this.returnUrl;
    //   } else {
    //     this.router.navigate(['/promotor-dashboard']);
    //   }
    // } else {
    //   if (this.returnUrl) {
    //     window.location.href = this.returnUrl;
    //   }else{
    //     this.router.navigate(['/promotor-dashboard']);
    //     this.viewSidebarRight.set(false);
    //   }
    // }
  }
    
}